const LEAKED_TOOL_CALL_PATTERN = /\[\s*\{(?:[^{}]|\{[^{}]*\})*"toolName"[\s\S]*?\}\s*\]/g;

/** Remove model-authored tool invocation JSON that must never appear in staff-facing chat. */
export function stripLeakedToolCalls(text: string): string {
  const stripped = text
    .replace(LEAKED_TOOL_CALL_PATTERN, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
  return stripped;
}
